import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import { useFormattingContext } from '../../FormattingProvider/FormattingContext'
import Ring from '../../../charts/echarts/Ring'

/**
 * Ring/gauge layout — uses the standalone Ring component (owns its own ECharts instance).
 */
function RingChartLayout ({ config, data, styleOverrides }) {
  const {
    height = 300,
    width = 300,
    metrics = [],
    valueFormat = 'percentage',
    seriesOverrides = null
  } = config

  const variantStyles = styleOverrides?.styles ?? {}

  const { formatter } = useFormattingContext()

  const ringData = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0 || metrics.length === 0) return []

    const row = data[0]
    return metrics.map(m => {
      let value = Number(get(row, m.accessor)) || 0
      if (m.target != null) {
        const target = typeof m.target === 'string'
          ? Number(get(row, m.target)) || 1
          : Number(m.target) || 1
        value = value / target
      }
      return {
        value,
        name: m.name || m.accessor
      }
    })
  }, [data, metrics])

  const valueFormatter = useMemo(
    () => (v) => formatter(v, valueFormat),
    [formatter, valueFormat]
  )

  if (ringData.length === 0) return null

  return (
    <Ring
      height={height}
      width={width}
      data={ringData}
      valueFormat={valueFormatter}
      {...(variantStyles.ringWidth != null && { ringWidth: variantStyles.ringWidth })}
      {...(styleOverrides?.props ?? {})}
      {...(seriesOverrides && { chartOptions: seriesOverrides })}
    />
  )
}

RingChartLayout.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  styleOverrides: PropTypes.object
}

export default RingChartLayout
